import { ArrowRight, Calculator, FileSpreadsheet, ShieldCheck } from "lucide-react";
import { SERVICES } from "@/components/calculator/schemas";

const ICONS = { FileSpreadsheet, ShieldCheck, Calculator };

export const ServiceChooser = ({ selected, onSelect }) => (
  <div
    data-testid="service-chooser"
    className="grid grid-cols-1 gap-5 md:grid-cols-3"
    role="group"
    aria-label="Choose the service you need a price for"
  >
    {SERVICES.map((service) => {
      const Icon = ICONS[service.icon] || Calculator;
      const isSelected = selected === service.key;
      return (
        <button
          key={service.key}
          type="button"
          data-testid={service.testId}
          aria-pressed={isSelected}
          onClick={() => onSelect(service.key)}
          className={`tt-card tt-card-hover group flex h-full flex-col p-6 text-left outline-none focus-visible:ring-2 focus-visible:ring-primary/40 ${
            isSelected ? "border-primary shadow-[inset_0_0_0_2px_var(--tt-teal)]" : ""
          }`}
        >
          <div className="flex items-start justify-between gap-3">
            <span
              className={`inline-flex h-12 w-12 items-center justify-center rounded-lg transition-colors duration-200 ${
                isSelected
                  ? "bg-primary text-white"
                  : "bg-[color:var(--tt-teal-mist)] text-primary group-hover:bg-primary group-hover:text-white"
              }`}
            >
              <Icon className="h-6 w-6" aria-hidden="true" />
            </span>
            <span className="rounded-full border border-[color:var(--tt-teal-line)] bg-[color:var(--tt-teal-mist)] px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.1em] text-[color:var(--tt-teal-deep)]">
              {service.priceHint}
            </span>
          </div>

          <h3 className="mt-5 text-[19px] font-bold leading-snug text-foreground">
            {service.title}
          </h3>
          <p className="mt-2 text-sm font-medium leading-relaxed text-[color:var(--tt-teal-deep)]">
            {service.tagline}
          </p>
          <p className="mt-3 flex-1 text-[13px] leading-relaxed text-muted-foreground">
            {service.detail}
          </p>

          <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-primary">
            {isSelected ? "Selected" : "Start this quote"}
            <ArrowRight
              className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1"
              aria-hidden="true"
            />
          </span>
        </button>
      );
    })}
  </div>
);
